import { Component, OnInit } from '@angular/core';

@Component({
  selector: "app-gotoschool",
  templateUrl: "./gotoschool.component.html",
  styleUrls: ["./gotoschool.component.css"],
})
export class GotoschoolComponent implements OnInit {
  constructor() {}
  currentYear: number = new Date().getFullYear();

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/gotoschool/gotoschool.component.ts